export const EMAILS_ADDRESSES_FIELD_HELPER_TEXT =
  'To add email address, press "enter" after each email address. Add only one email address per client.';

export const EMAILS_ADDRESSES_FIELD_SHORT_HELPER_TEXT =
  'To add email address, press "enter" after each email address.';
